import MessageApi from '../../../../api/inbox/message';

export default {
  async translateMessage(_, { conversationId, messageId, targetLanguage }) {
    try {
      await MessageApi.translateMessage(
        conversationId,
        messageId,
        targetLanguage
      );
    } catch (error) {
      // ignore error
    }
  },

  async transcribeMessage({ dispatch }, { conversationId, messageId }) {
    const { data } = await MessageApi.transcribeMessage(
      conversationId,
      messageId
    );
    if (data) {
      dispatch('updateMessage', data);
    }
    return data;
  },
};
